export const updateSubscriptionStatus = (status) => {
  localStorage.setItem("subscription", status);
  // Create and dispatch a custom event
  const event = new Event("subscriptionChanged");
  window.dispatchEvent(event);
  // Also dispatch storage event for backward compatibility
  window.dispatchEvent(new StorageEvent("storage", {
    key: "subscription",
    newValue: status
  }));
};
